import { NodeViewWrapper } from '@tiptap/react';

import * as Styled from './richtext-custom-readonly-placeholder.style';

const RichtextCustomReadonlyPlacholder = (props: any) => (
  <NodeViewWrapper
    className="richtext-readonly"
    contentEditable={false}
    as="span"
  >
    <Styled.RichtextReadonlyPlaceholder
      className="label"
      contentEditable={false}
    >
      {props.node.attrs.text}
    </Styled.RichtextReadonlyPlaceholder>
  </NodeViewWrapper>
);

export default RichtextCustomReadonlyPlacholder;
